import { API_URLS } from 'utils/apiUtils';
import axios from 'axios';
import httpRequest from './httpRequest';
import { postTodo } from 'apis/common.api';

class AuthService {
  handleAuthentication = () => {
    const accessToken = this.getAccessToken();
    if (!accessToken || !this.isValidToken(accessToken)) return;
    this.setSession('accessToken', accessToken);
  };

  loginWithAuth0 = async (email: string, password: string) => {
    try {
      const res = await postTodo(API_URLS.LOGIN_ADMIN, {
        email,
        password,
      });

      const { token, username, role, state, passwordUpdated } = res.data;
      this.setSession('accessToken', token);

      /* this.setSession('refreshToken', data.data.data.refresh_token); */
      const userStringify = JSON.stringify({ username, roleUser: role.toUpperCase(), role: role.toUpperCase(), state: state, passwordUpdated });
      this.setSession('user', userStringify);
      return {
        user: username,
        role: role.toUpperCase(),
        passwordUpdated,
        error: null,
        state,
      };
    } catch (err: any) {
      console.log('error->', err);
      return {
        user: null,
        role: null,
        error: err.response.data.message,
      };
    }
  };
  // loginWithAuth0 = async (username: string, roleUser: string) => {
  //      const data = await httpRequest.post(API_URLS.LOGIN_ADMIN, {
  //     data: {
  //       email: 'tony@gmail.com',
  //       password: '123456',
  //     },
  //   });
  //   this.setSession('accessToken', 'tokenjwt');
  //   /* this.setSession('refreshToken', data.data.data.refresh_token); */
  //   const userStringify = JSON.stringify({ username, roleUser });
  //   this.setSession('user', userStringify);
  //   return {
  //     user: username,
  //     role: roleUser,
  //   };
  // };

  loginWithToken = async () => {
    return {
      user: 'tonynguyen',
    };
  };

  setSession = (key: string, accessToken: string) => {
    localStorage.setItem(key, accessToken);
  };

  logOut = () => {
    localStorage.clear();
  };

  getUser = () => {
    const user = localStorage.getItem('user') || '';
    return user;
  };

  getAccessToken = () => {
    let user = null;
    try {
      user = JSON.parse(this.getUser());
    } catch (e) {}
    //@ts-ignore
    if (user?.passwordUpdated || user?.role?.toLowerCase() == 'admin') {
      return localStorage.getItem('accessToken');
    } else {
      return null;
    }
  };

  isAuthenticated = () => !!this.getAccessToken();

  isValidToken = (accessToken: string | null) => {
    const expireTime = 1606275140.897;
    if (!accessToken) return false;

    const currentTime = Date.now() / 1000;

    return expireTime < currentTime;
  };
}

const authService = new AuthService();

export default authService;
